<i class="far fa-question-circle" popover="{{ helpText }}" triggers="hover"></i>
